// Note : Order of imports matters most here, until we manage to get rid of ui bibz.
//
// 1. Imports jquery, then jquery-ui
// 2. Then imports ui bibz, that is patching jquery and importing bootstrap.
// 3. Then imports same version of boostrap as ui bibz.

// 1. Imports jquery.
import $ from 'jquery'
window.$ = $
window.jQuery = $
window.jquery = $

export { $ }

import 'jquery-ui/dist/jquery-ui.js'

// 2. Then imports ui bibz, that is patching jquery and importing bootstrap.
import * as UiBibz from './ui_bibz.js'
export { UiBibz }

// 3. Then imports same version of boostrap as ui bibz.
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
window.bootstrap = bootstrap
window.Bootstrap = bootstrap
export { bootstrap }

import './stylesheets/application.sass'
import 'patternomaly'
import './src/utils.js'
import './src/vendor/mspace.js' // Enable MathML on Google Chrome
import './i18n.js'

import * as Routes from './routes.js'
window.Routes = Routes

// Don't visit and cache blacklisted page with turbo
document.addEventListener('turbo:before-visit', function(event) {
  let url = event.detail.url.split(window.location.origin)[1]
  let isBlacklisted = window.turboBlacklist.includes(url)
  if (isBlacklisted){
    console.warn('Turbo visit to %o cancelled due to turbo blacklist, debug with ?debug[turbo-blacklist]=1', url, event)
    event.preventDefault()
    return false
  }
})

// Reload ui-bibz elements on page re-render
UiBibz.init(document)
window.addEventListener('load', (event) => {
  UiBibz.init(event.target)
})
document.addEventListener('turbo:render', (event) => {
  UiBibz.init(event.target)
})
